import React, { useState } from 'react';
import BusquedaProductosTab from './PriceListSkuSearch';
import PriceListPriceSearch from './PriceListPriceSearch';
import DescuentosTab from './PriceListDiscounts';
import { useSkuEntitlements, can } from './PriceListEntitlements';
import './PriceList.css';

type Tab = 'busqueda productos' | 'busqueda precios' | 'descuentos';

const PriceList: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('busqueda productos');
  const [pendingSearch, setPendingSearch] = useState<{ pn: string } | null>(null);
  const entitlements = useSkuEntitlements();

  const showProductsTab  = can.searchProducts(entitlements);
  const showPricesTab    = can.searchSku(entitlements);
  const showDiscountsTab = can.viewDiscounts(entitlements);
  const hasAnyTab        = showProductsTab || showPricesTab || showDiscountsTab;

  // If the currently selected tab becomes hidden, fall back to the first visible one.
  const safeActiveTab: Tab = (() => {
    const visible: Tab[] = [
      ...(showProductsTab  ? ['busqueda productos' as Tab] : []),
      ...(showPricesTab    ? ['busqueda precios'   as Tab] : []),
      ...(showDiscountsTab ? ['descuentos'         as Tab] : []),
    ];
    return visible.includes(activeTab) ? activeTab : (visible[0] ?? 'busqueda productos');
  })();

  if (!hasAnyTab) {
    return (
      <div>
        <h1>Lista de Precios</h1>
        <p className="pricelist-error">Sin acceso. Contacte al administrador para obtener permisos.</p>
      </div>
    );
  }

  return (
    <div>
      <h1>Lista de Precios</h1>

      <div className="pricelist-tabs">
        {showProductsTab && (
          <button
            className={`pricelist-tab${safeActiveTab === 'busqueda productos' ? ' pricelist-tab--active' : ''}`}
            onClick={() => setActiveTab('busqueda productos')}
          >
            Búsqueda Productos
          </button>
        )}
        {showPricesTab && (
          <button
            className={`pricelist-tab${safeActiveTab === 'busqueda precios' ? ' pricelist-tab--active' : ''}`}
            onClick={() => setActiveTab('busqueda precios')}
          >
            Búsqueda Precios
          </button>
        )}
        {showDiscountsTab && (
          <button
            className={`pricelist-tab${safeActiveTab === 'descuentos' ? ' pricelist-tab--active' : ''}`}
            onClick={() => setActiveTab('descuentos')}
          >
            Descuentos
          </button>
        )}
      </div>

      <div className="pricelist-tab-content">
        {showProductsTab && (
          <div style={{ display: safeActiveTab === 'busqueda productos' ? undefined : 'none' }}>
            <BusquedaProductosTab
              onVerPrecios={(pn) => { setPendingSearch({ pn }); setActiveTab('busqueda precios'); }}
            />
          </div>
        )}

        {showPricesTab && (
          <div style={{ display: safeActiveTab === 'busqueda precios' ? undefined : 'none' }}>
            <PriceListPriceSearch pendingSearch={pendingSearch} />
          </div>
        )}

        {showDiscountsTab && (
          <div style={{ display: safeActiveTab === 'descuentos' ? undefined : 'none' }}>
            <DescuentosTab />
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceList;
